<template>
  <div @click="(e) => e.stopPropagation()">
    <v-menu bottom left offset-y>
      <div
        slot="activator"
        :class="{ 'circle-status': true, border: !backgroundColor }"
        :style="{
          backgroundColor: backgroundColor,
        }"
      ></div>
      <div class="dt-list-v2" style="background-color: white">
        <div
          style="cursor: pointer"
          class="ut-flex dt-list--item"
          v-for="(statusItem, index) in statusTVList"
          :key="index"
          @click="
            onChange({
              itemID: item.itemID,
              colorPropertyName: item.colorPropertyName,
              colorPropertyValue: statusItem.id,
              colorValue: statusItem.value,
              colorName: item.colorName,
            })
          "
        >
          <div
            class="circle-status"
            :style="{
              backgroundColor: `#${statusItem.value}`,
              height: '16px',
              width: '16px',
              minWidth: '16px',
            }"
          ></div>
          {{ statusItem.text }}
        </div>
      </div>
    </v-menu>
  </div>
</template>
<script>
export default {
  props: {
    statusTVList: {
      type: Array,
    },
    item: {
      type: Object,
    },
  },
  components: {},
  data: () => ({}),
  computed: {
    backgroundColor: function () {
      return this.item.colorValue ? `#${this.item.colorValue}` : "";
    },
  },

  methods: {
    onChange: function (payload) {
      console.log("::::::::", payload, "::::::::::::", this.item);
      this.$emit("updateStatus", { ...payload });
      //this[ActionTypes.ReleaseList.UPDATE.SINGLE](payload);
    },
  },
};
</script>
<style lang="scss">
</style>
